export const LAST_NON_ADMIN_ROUTE_KEY = 'admin.lastNonAdminRoute';

const RETURN_ROUTE_PREFIXES = ['/ipa', '/ira', '/isa', '/analise', '/acompanhamento', '/upload'];

const isSafeReturnRoute = route => {
  return typeof route === 'string' && RETURN_ROUTE_PREFIXES.some(prefix => route === prefix || route.startsWith(`${prefix}/`));
};

export const getLastNonAdminRoute = () => {
  const route = window.sessionStorage.getItem(LAST_NON_ADMIN_ROUTE_KEY);

  return isSafeReturnRoute(route) ? route : null;
};

export const clearLastNonAdminRoute = () => {
  window.sessionStorage.removeItem(LAST_NON_ADMIN_ROUTE_KEY);
};

export const setLastNonAdminRoute = route => {
  if (!isSafeReturnRoute(route)) return;

  window.sessionStorage.setItem(LAST_NON_ADMIN_ROUTE_KEY, route);
};

export const syncLastNonAdminRoute = route => {
  if (typeof route === 'string' && route.startsWith('/administrador')) return;

  if (isSafeReturnRoute(route)) {
    setLastNonAdminRoute(route);
    return;
  }

  clearLastNonAdminRoute();
};
